// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkout/Warning/style.css
// module id = 1783
// module chunks = 0